<template>
  <div>
    <h2 class="text-h3 mb-3">Source Articles</h2>
    <NewsTab :market="slug" :categories-articles="categoriesArticles" />
  </div>
</template>

<script lang="ts" setup>
import NewsTab from '~/components/market-insights/NewsTab.vue'

definePageMeta({ isTab: true })

defineProps<{
  slug: string
  categoriesArticles?: string[]
}>()
</script>
